<template>
  <div class="pagination">
    <button class="page-btn prev cat-paw" :disabled="currentPage === 1" @click="onPageChange(currentPage - 1)">
      &lt;
    </button>
    <div class="page-numbers">
      <button 
        v-for="page in displayedPages" 
        :key="page" 
        :class="['page-btn', { active: page === currentPage }]"
        @click="onPageChange(page)"
      >
        {{ page }}
      </button>
    </div>
    <button class="page-btn next cat-paw" :disabled="currentPage === totalPages" @click="onPageChange(currentPage + 1)">
      &gt;
    </button>
  </div>
</template>

<script>
export default {
  name: 'StickerPagination',
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    totalPages: {
      type: Number,
      required: true
    }
  },
  computed: {
    displayedPages() {
      const pages = [];
      let startPage = Math.max(1, this.currentPage - 2);
      let endPage = Math.min(this.totalPages, this.currentPage + 2);
      
      // Always show 5 pages if possible
      if (endPage - startPage < 4) {
        if (startPage === 1) {
          endPage = Math.min(5, this.totalPages);
        } else {
          startPage = Math.max(1, this.totalPages - 4);
        }
      }
      
      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
      
      return pages;
    }
  },
  methods: {
    onPageChange(page) {
      this.$emit('page-change', page);
    }
  }
}
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  margin: 30px 0;
}

.page-btn {
  min-width: 30px;
  height: 30px;
  margin: 0 5px;
  background-color: #fff;
  border: 1px solid #e8f5e9;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.page-btn:hover:not(:disabled):not(.active) {
  background-color: #f1f8e9;
  border-color: #c8e6c9;
}

.page-btn.active {
  background-color: #42b983;
  border-color: #42b983;
  color: white;
}

.page-btn:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.cat-paw::after {
  content: "🐾";
  font-size: 10px;
  position: absolute;
  top: -10px;
  right: -5px;
  opacity: 0;
  transition: opacity 0.3s;
}

.cat-paw:hover::after:not(:disabled) {
  opacity: 1;
}

.page-numbers {
  display: flex;
}

.prev, .next {
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
}

.prev::before {
  content: "🐱";
  position: absolute;
  font-size: 0;
  transition: font-size 0.3s;
}

.next::before {
  content: "🐱";
  position: absolute;
  font-size: 0;
  transition: font-size 0.3s;
}

.prev:hover:not(:disabled)::before,
.next:hover:not(:disabled)::before {
  font-size: 12px;
}
</style>